import { render, staticRenderFns } from "./DeviceDetailsReviews.vue?vue&type=template&id=90598d5c&"
import script from "./DeviceDetailsReviews.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90598d5c')) {
      api.createRecord('90598d5c', component.options)
    } else {
      api.reload('90598d5c', component.options)
    }
    module.hot.accept("./DeviceDetailsReviews.vue?vue&type=template&id=90598d5c&", function () {
      api.rerender('90598d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceDetailsReviews.vue"
export default component.exports